<template>
    <v-bottom-sheet
        v-model="menuVisible"
        max-width="600px"
    >
        <v-list dense>
            <v-subheader
                class="d-flex justify-space-between align-center"
                style="border-bottom: 1px solid gray; margin-bottom: 8px;"
            >
                <div class="text-truncate text--primary ml-3">
                    {{ sectionDetails.sectionTitle }}
                </div>
                <v-icon @click="closeMenu" style="cursor: pointer; margin-right: 8px;">mdi-close</v-icon>
            </v-subheader>
            <v-card class="elevation-0" v-if="canShowAIN">
                <v-card-title class="subtitle-2 font-weight-bold pb-2">
                    AI Navigator
                </v-card-title>
                <v-list dense>
                    <v-list-item @click="askQuestion">
                        <v-list-item-content>
                            <v-list-item-title class="d-flex align-center">
                                <v-list-item-icon style="width: 40px; margin: 8px 8px 8px 0 !important;">
                                    <v-icon>mdi-message-outline</v-icon>
                                </v-list-item-icon>
                                <span>Ask question</span>
                                <v-list-item-icon
                                    v-if="!isAinAllowed"
                                    class="ml-2">
                                    <v-icon small>mdi-lock-outline</v-icon>
                                </v-list-item-icon>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="summarizeSection">
                        <v-list-item-content>
                            <v-list-item-title class="d-flex align-center">
                                <v-list-item-icon style="width: 40px; margin: 8px 8px 8px 0 !important;">
                                    <v-icon>mdi-format-list-bulleted</v-icon>
                                </v-list-item-icon>
                                <span>Summarize section</span>
                                <v-list-item-icon
                                    v-if="!isAinAllowed"
                                    class="ml-2">
                                    <v-icon small>mdi-lock-outline</v-icon>
                                </v-list-item-icon>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
            <ain-premium-required-dialog :isDialogActive.sync="displayAinRequiredDialog" />
            <v-divider v-if="canShowAIN"></v-divider>
            <v-list-item
                v-for="(item, key) in typeToEventMap"
                :key="key"
                @click="handleClick(item)"
            >
                <v-list-item-content>
                    <v-list-item-title class="d-flex align-center">
                        <v-list-item-icon style="width: 40px; margin: 8px 8px 8px 0 !important;">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <span>{{ item.title }}</span>
                        <v-list-item-icon
                            v-if="!sectionDetails.contentRestrictions[item.actionName]
                            && item.type === 'premium'"
                            class="ml-2">
                            <v-icon small>mdi-lock-outline</v-icon>
                        </v-list-item-icon>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-bottom-sheet>
</template>

<script>
import Mobile from '../inc/mixins/mobile';
import NewToolBarActions from './mixins/NewToolBarActions';
import AinPremiumRequiredDialog from './AinPremiumRequiredDialog.vue';

export default {
    components: {AinPremiumRequiredDialog},
    mixins: [Mobile, NewToolBarActions],
    data() {
        return {
            menuVisible: false,
            displayAinRequiredDialog: false,
            sectionDetails: {
                sectionId: null,
                documentId: null,
                sectionTitle: null,
                sectionContent: null,
                contentRestrictions: {
                    aiNavigationSectionRestrictions: {
                        canShowIcon: false,
                        canUseAiFunctions: false
                    },
                    canBookmark: false,
                    canCopy: false,
                    canPrint: false,
                    canShare: false,
                }
            },
            typeToEventMap: {
                copyText: {
                    title: 'Copy text',
                    icon: 'mdi-content-copy',
                    event: 'toolbar-action-copy',
                    actionName: 'canBookmark'
                },
                openNoteModal: {
                    title: 'Add note, bookmark or highlight',
                    icon: 'mdi-bookmark-plus-outline',
                    event: 'toolbar-action-note-bookmark',
                    actionName: 'canCopy'
                },
                togglePrint: {
                    title: 'Print',
                    icon: 'mdi-printer-outline',
                    event: 'toolbar-action-print-section',
                    actionName: 'canPrint'
                },
                copyLink: {
                    title: 'Copy link',
                    icon: 'mdi-link',
                    event: 'toolbar-action-copy-link',
                    actionName: 'canShare'
                },
            }
        };
    },
    computed: {
        hasAiNavAccess() {
            return this.sectionDetails.contentRestrictions.aiNavigationSectionRestrictions.canShowIcon
            && this.sectionDetails.contentRestrictions.aiNavigationSectionRestrictions.canUseAiFunctions;
        },
        canShowAIN() {
            return this.sectionDetails.contentRestrictions.aiNavigationSectionRestrictions.canShowIcon;
        },
        isAinAllowed() {
            return this.sectionDetails.contentRestrictions.aiNavigationSectionRestrictions.canUseAiFunctions;
        }
    },
    methods: {
        handleClick(item) {
            const { event, type, actionName } = item;

            if (!this.sectionDetails.contentRestrictions[actionName]) {
                EventBus.fire('subscription-prompt');
            } else {
                const handlers = {
                    'toolbar-action-copy': () => this.copyTextAction(this.sectionDetails.sectionId),
                    'toolbar-action-note-bookmark': () => this.toggleBookmarkActionNew(this.sectionDetails),
                    'toolbar-action-print-section': () => this.printAction(this.sectionDetails.documentId, this.sectionDetails.sectionId),
                    'toolbar-action-copy-link': () => this.shareLinkAction(this.sectionDetails.sectionId),
                };

                const action = handlers[event];
                if (action) action();
            }
            this.menuVisible = false;
        },
        closeMenu() {
            this.menuVisible = false;
        },
        askQuestion() {
            if (!this.hasAiNavAccess) {
                this.displayAinRequiredDialog = true;
            }
            //TODO: implement AI logic
        },
        summarizeSection() {
            if (!this.hasAiNavAccess) {
                this.displayAinRequiredDialog = true;
            }
            //TODO: implement AI logic
        }
    },
    created() {
        EventBus.listen('show-toolbar-actions-mobile', (data) => {
            this.menuVisible = this.isMobilePort;
            this.sectionDetails = data;
        });
    },
};
</script>
